import React, { useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { Calendar, Tag, User, Clock } from 'lucide-react';
import { useData } from '../context/DataContext';
import ArticleRenderer from '../components/ArticleRenderer';

const ArticlePage = () => {
  const { id } = useParams();
  const { articles, trackPageView } = useData();
  
  const article = articles.find(a => a.id === id);

  useEffect(() => {
    if (article) {
      trackPageView(`article-${article.id}`);
    }
  }, [article, trackPageView]);

  if (!article) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="page-container">
      <div className="script-header">
        <h1 className="script-title">{article.title}</h1>
        <div className="script-meta">
          <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <Tag size={16} />
            {article.category} - {article.subcategory}
          </span>
          <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <User size={16} />
            {article.author}
          </span>
          <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <Clock size={16} />
            {article.readTime}
          </span>
          <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <Calendar size={16} />
            {new Date(article.createdAt).toLocaleDateString()}
          </span>
        </div>
      </div>

      <div className="script-content">
        <ArticleRenderer content={article.content} />
      </div>
    </div>
  );
};

export default ArticlePage;